import React from 'react';
import ChecklistElement from './ChecklistElementModel';
import EditorType from '../../../Enums/EditorType';
import type { JSX } from 'react';
import { formFocusNextKeyboard } from 'shouldve-been-react';
import { QuickTextInput } from 'shouldve-been-mui';

class TextFieldChecklistElement extends ChecklistElement {

    private _defaultValue: string | null;
    private _maxLength: number | null;

    public constructor(elementId: string, name: string, itemNumber: string | null, sortNumber: number, defaultValue: string | null, maxLength: number | null) {

        super(elementId, name, itemNumber, sortNumber, EditorType.TEXTFIELD);
        this._defaultValue = defaultValue;
        this._maxLength = maxLength;
    }

    public get defaultValue(): string | null {
        return this._defaultValue;
    }

    public set defaultValue(value: string | null) {
        this._defaultValue = value;
    }

    public get maxLength(): number | null {
        return this._maxLength;
    }

    public set maxLength(value: number | null) {
        this._maxLength = value;
    }

    public buildFormElement(value: string, onBlur: (value: string) => Promise<void>, screenWidth: number): JSX.Element {

        return (
            <React.Fragment key={this.elementId}>
                <QuickTextInput
                    value={value}
                    onBlur={onBlur}
                    variant='outlined'
                    dense={true}
                    minWidth={Math.min(screenWidth * 0.8, 500)}
                    maxWidth={Math.min(screenWidth * 0.8, 500)}
                    labelText={this.name}
                    height='40px'
                    maxLength={this.maxLength}
                    onKeyDown={formFocusNextKeyboard}
                />
                <br />
                <br />
            </React.Fragment>
        );
    }
}

export default TextFieldChecklistElement;